import { Edge, Node } from '@xyflow/react';
import JSZip from 'jszip';
import { IVlanItem, GlobalSettingsType } from 'src/context/global/types';

import { getConfiguration } from './get-configuration';

export const exportAutoConfiguration = async ({
  nodes: allNodes,
  edges,
  vlans,
  targets,
  selectedNode,
  projectName,
  globalSettings,
}: {
  nodes: Node[];
  edges: Edge[];
  vlans: IVlanItem[];
  targets: {
    id: string;
    name: string;
  }[];
  selectedNode: string;
  projectName: string;
  globalSettings: GlobalSettingsType;
}) => {
  const configurationFiles: File[] = [];

  const autoDeployIps = targets.map((target, index) => ({
    id: target.id,
    name: target.name,
    ip: `172.31.255.${index + 1}`,
  }));

  await Promise.all(
    targets.map(async (target) => {
      const file = await getConfiguration({
        nodes: allNodes,
        edges,
        vlans,
        cfgName: target.name,
        targetId: target.id,
        isAutoDeploy: true,
        autoDeployIps,
        globalSettings,
      });
      configurationFiles.push(file);
    }),
  );

  // zip the files
  const zip = new JSZip();

  const filesFolder = zip.folder('files');

  configurationFiles.forEach((file) => {
    filesFolder?.file(file.name, file);
  });

  // add file command.txt
  const commandContents = ['files upload'];
  const selectedNodeName = targets.find((item) => item.id === selectedNode);
  if (selectedNodeName) {
    commandContents.push(
      `apply config file files/${selectedNodeName?.name}.cfg`,
    );
  } else {
    throw new Error('Selected node not found');
  }

  const commandFile = new File([commandContents.join('\n')], 'command.txt', {
    type: 'text/plain',
  });
  zip.file('command.txt', commandFile);

  const zipFile = await zip.generateAsync({ type: 'blob' });

  const element = document.createElement('a');
  element.href = URL.createObjectURL(zipFile);
  element.download = `${projectName}.zip`;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
  document.body.removeChild(element);
};
